export const getStoredUser = () => {
  try {
    const storedUser = window.localStorage.getItem('user');
    return storedUser ? JSON.parse(storedUser) : null;
  } catch (error) {
    console.error('Unable to parse the stored user.', error);
    return null;
  }
};

const ADMIN_IMPERSONATION_SESSION_KEY = 'adminImpersonationSession';

export const saveAdminImpersonationSession = () => {
  const user = getStoredUser();
  const accessToken = window.localStorage.getItem('accessToken') || user?.access_token;
  if (!user || user?.role === 'Customer' || !accessToken) return false;

  window.sessionStorage.setItem(
    ADMIN_IMPERSONATION_SESSION_KEY,
    JSON.stringify({ user, accessToken })
  );
  return true;
};

export const getAdminImpersonationSession = () => {
  try {
    const storedSession = window.sessionStorage.getItem(ADMIN_IMPERSONATION_SESSION_KEY);
    if (!storedSession) return null;

    const session = JSON.parse(storedSession);
    if (!session?.user || session.user?.role === 'Customer' || !session?.accessToken) {
      window.sessionStorage.removeItem(ADMIN_IMPERSONATION_SESSION_KEY);
      return null;
    }
    return session;
  } catch (error) {
    window.sessionStorage.removeItem(ADMIN_IMPERSONATION_SESSION_KEY);
    return null;
  }
};

export const clearAdminImpersonationSession = () => {
  window.sessionStorage.removeItem(ADMIN_IMPERSONATION_SESSION_KEY);
};
